import React from "react";
import Joi from "joi-browser";
import Form from "../../components/authForm";
import generator from "generate-password";
import { getUser } from "../../services/usersService";

import { NavLink } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import WithSpinner from "./../../components/withSpinner";
import { addAdminAsync } from "../../redux/users/users.action";
import { selectLoadingStatus } from "../../redux/users/users.selector";

class AddUser extends Form {
  state = {
    data: {
      username: "",
      role: "",
      email: "",
      password: "",
    },
    role: ["admin", "super admin"],
    error: {},
  };

  schema = {
    _id: Joi.string(),
    username: Joi.string().min(3).max(20).required().label("Username"),
    role: Joi.string().required().label("Role"),
    email: Joi.string().email().required().label("Email"),
    password: Joi.string().allow("").optional().label("Password"),
  };

  doSubmit = async () => {
    const { addAdminAsync, match } = this.props;
    await addAdminAsync(this.state.data);

    if (match.params.id === "new") {
      this.setState({
        data: {
          username: "",
          role: "",
          email: "",
          password: "",
        },
      });
    }
  };

  async componentDidMount() {
    const { match } = this.props;
    const id = match.params.id;
    document.title =
      id === "new" ? "African Movies | Add User" : "African Movies | Update User";

    if (id === "new") {
      var password = generator.generate({
        length: 10,
        numbers: true,
        symbols: true,
        lowercase: true,
        uppercase: true,
        strict: true,
      });
      this.setState({
        data: {
          username: "",
          role: "",
          email: "",
          password,
        },
      });
    } else {
      const { data: user } = await getUser(id);
      this.setState({
        data: {
          _id: user._id,
          username: user.username || "",
          role: user.role || "",
          email: user.email || "",
          password: "",
        },
      });
    }
  }

  render() {
    const { isLoading, match } = this.props;
    const btnLabel = match.params.id === "new" ? "Add User" : "Update User";
    return isLoading ? (
      <WithSpinner />
    ) : (
      <React.Fragment>
        <section className="auth">
          <div className="row auth-row no-gutter">
            <div
              className="col-md-12 bg-light-black"
              style={{ borderRadius: "8px" }}
            >
              <div className="container  d-flex h-100">
                {match.params.id !== "new" && (
                  <NavLink
                    style={{
                      marginTop: "100px",
                      marginLeft: "30px",
                      color: "#fff",
                    }}
                    to="/users"
                  >
                    <AiOutlineArrowLeft size="20" /> Back
                  </NavLink>
                )}
                <span className="m-auto">
                  <form
                    action="dashboard.html"
                    onSubmit={this.handleSubmit}
                    style={{ marginTop: "-80px" }}
                  >
                    {match.params.id !== "new" && (
                      <span>
                        Kindly fill the field you want to update and save
                      </span>
                    )}
                    <br />
                    {this.renderInput(
                      "text",
                      "username",
                      "Username",
                      "Username"
                    )}
                    {this.renderInput("text", "email", "Email", "Email")}
                    {this.renderSelect(
                      "role",
                      ["Click to Select", ...this.state.role],
                      "Role"
                    )}
                    <br />
                    {match.params.id === "new" && (
                      <div>
                        <span>Please note the generated password</span>
                        <br />
                        <span>
                          Password:{" "}
                          <span
                            style={{
                              color: "white",
                              fontWeight: "bolder",
                              fontSize: "20px",
                            }}
                          >
                            {this.state.data.password}
                          </span>
                        </span>
                        <br />
                      </div>
                    )}
                    {this.renderButton(`${btnLabel}`)}
                  </form>
                </span>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isLoading: selectLoadingStatus,
});

const mapDispatchToProps = (dispatch) => ({
  addAdminAsync: (payload) => dispatch(addAdminAsync(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
